import { defineStore } from "pinia";

export const useTitle = defineStore("title", {
	state: () => ({ pTitle: undefined }),
	getters: {
		titleStore: (state) => state.pTitle,
	},
	actions: {
		setTitle(_title, t) {
			if (this.pTitle !== _title) {
				const eventProperties = {
					title: t(_title),
				};
			}
			this.pTitle = _title;
		},
	},
});
